import { MovieStatus } from '@tmdb-graphql-api/schema/types';
import { format } from 'date-fns';
import { tt } from '#i18n/index.ts';

export const formatMovieReleaseDate = (releaseDate: string, status: MovieStatus): string => {
  const releaseDateObj = new Date(releaseDate);

  switch (status) {
    case MovieStatus.Canceled: {
      return `${tt('watchlist.releaseDates.CANCELED')} ${format(releaseDateObj, 'LLL yyyy')}`;
    }

    case MovieStatus.Rumored:

    // Same message for both
    // eslint-disable-next-line no-fallthrough
    case MovieStatus.Planned: {
      return `${tt(`watchlist.releaseDates.${status}`)} ${format(releaseDateObj, 'yyyy')}`;
    }

    case MovieStatus.InProduction: {
      return `${tt('watchlist.releaseDates.IN_PRODUCTION')} ${format(releaseDateObj, 'LLL yyyy')}`;
    }

    case MovieStatus.PostProduction:

    // Same message for both
    // eslint-disable-next-line no-fallthrough
    case MovieStatus.Released: {
      return `${tt(`watchlist.releaseDates.${status}`)} ${format(releaseDateObj, 'LLL M, yyyy')}`;
    }
  }
};
